import {
  addSupplierApi,
  updateSupplierApi,
  setSupplierCheckStateApi,
  getSupplierByIdApi,
  querySupplierApi,
  addSupplierShopApi,
  updateSupplierShopApi,
  setSupplierShopStateApi,
  getSupplierShopByIdApi,
  getSupplierShopListApi,
  querySupplierShopApi,
  queryOrderWriteOffCodeApi,
  setCommunityLeaderReceiveWxMsgTypeApi,
  getWithdrawInfoApi,
  deleteWithdrawInfoApi,
  querySupplierTicketUseApi,
  setSupplierIsOpenFunConfigApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  添加供应商信息
  async addSupplierAction(context, param) {
    const res = await addSupplierApi(param)
    return res
  },
  //  更新供应商信息
  async updateSupplierAction(context, param) {
    const res = await updateSupplierApi(param)
    return res
  },
  //  设置供应商审核状态
  async setSupplierCheckStateAction(context, param) {
    const res = await setSupplierCheckStateApi(param)
    return res
  },
  //  根据id获取供应商信息
  async getSupplierByIdAction(context, param) {
    const res = await getSupplierByIdApi(param)
    return res
  },
  //  查询供应商信息
  async querySupplierAction(context, param) {
    const res = await querySupplierApi(param)
    return res
  },
  //  添加供应商门店信息
  async addSupplierShopAction(context, param) {
    const res = await addSupplierShopApi(param)
    return res
  },
  //  修改供应商门店信息
  async updateSupplierShopAction(context, param) {
    const res = await updateSupplierShopApi(param)
    return res
  },
  //  设置供应商门店状态
  async setSupplierShopStateAction(context, param) {
    const res = await setSupplierShopStateApi(param)
    return res
  },
  //  根据id获取供应商门店信息
  async getSupplierShopByIdAction(context, param) {
    const res = await getSupplierShopByIdApi(param)
    return res
  },
  //  获取供应商门店信息列表
  async getSupplierShopListAction(context, param) {
    const res = await getSupplierShopListApi(param)
    return res
  },
  //  查询供应商门店信息
  async querySupplierShopAction(context, param) {
    const res = await querySupplierShopApi(param)
    return res
  },
  //  查询订单核销码
  async queryOrderWriteOffCodeAction(context, param) {
    const res = await queryOrderWriteOffCodeApi(param)
    return res
  },
  //  设置社区团长接收微信消息类型
  async setCommunityLeaderReceiveWxMsgTypeAction(context, param) {
    const res = await setCommunityLeaderReceiveWxMsgTypeApi(param)
    return res
  },
  //  获取供应商提现账户信息
  async getWithdrawInfoAction(context, param) {
    const res = await getWithdrawInfoApi(param)
    return res
  },
  //  删除提现账户
  async deleteWithdrawInfoAction(context, param) {
    const res = await deleteWithdrawInfoApi(param)
    return res
  },
  //  查询供应商电子券使用
  async querySupplierTicketUseAction(context, param) {
    const res = await querySupplierTicketUseApi(param)
    return res
  },
  //  设置供应商是否开启功能配置
  async setSupplierIsOpenFunConfigAction(context, param) {
    const res = await setSupplierIsOpenFunConfigApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
